import { EComponentName } from "../enum/EComponentName";

export class SnackbarModel {
    Message: string | undefined;
    Name:EComponentName|undefined;   
}